export default __webpack_public_path__ + "static/media/search.51592236.svg";